import { FC } from 'react'
import { useTranslation } from 'next-i18next'
import { IJobBase } from '@/types'
import { ContextWithLink } from '@components-v2/atoms/ContextWithLink'
import { NoContent } from '@components-v2/atoms/NoContent'
import { JobCardList } from '@components-v2/molecules/JobCardList'
import { useRouter } from 'next/router'
import styles from './index.module.scss'

type Props = {
  jobs: IJobBase[]
  isCompanyMember?: boolean
  companySlug?: string
}

export const CompanyProfileJobs: FC<Props> = ({ jobs, companySlug, isCompanyMember }) => {
  const { t } = useTranslation(['jobs', 'p'])

  const { locale } = useRouter()

  const renderContent = () => {
    if (isCompanyMember) {
      return (
        <ContextWithLink
          href={`/${locale || 'en'}/companies/${companySlug}/account/recruit/jobs`}
          i18nKey='p:求人作成ページへのリンク'
          upperText='求人はまだ掲載されていません。'
          lowerText='から求人の募集を掲載しましょう。'
        />
      )
    }

    return <NoContent>{t('求人はまだ掲載されていません。')}</NoContent>
  }
  return <div className={styles.container}>{jobs?.length === 0 ? renderContent() : <JobCardList jobs={jobs} />}</div>
}
